import React from "react";
import Skelton from "../skeleton/Skeleton";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Timestampmsg from "../../Dashboard/Timestampmsg"
import { tabManager } from "../../sidebar/sidebarSlice";
import { useDispatch } from "react-redux";
import { Download } from "lucide-react";
import { useColumnPreferences } from "../../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "./TableToolbar";

// One <table> per currentTable subtitle (Withdrawal/Deposit/PlaceBet/Event
// Level/Market Level, etc.) - each needs its own column preferences, so this
// is a separate component rather than calling the hook inside the parent's
// .map() (hooks can't be called conditionally/in a loop in the same component).
const ReportSubTable = ({ currentTable, isLast, tabsChange, parentProps }) => {
  const headers = currentTable?.headers?.[0] || [];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences(`reportsTable:${currentTable.subtitle}`, headers);

  return (
    <React.Fragment key={currentTable.subtitle}>
      <div className='rounded-lg border bg-card p-6'>
        <div className='CMS-box__header'>
          <div
            className='CMS-box__title'
            style={{ textAlign: "center" }}
          >
            {currentTable.subtitle}
          </div>
        </div>
        <div className='w-full'>
          <div className='w-full'>
            <div className='relative rounded-lg border bg-card shadow-sm'>
              <TableToolbar
                columns={allColumns}
                onToggle={toggleVisibility}
                onReorder={reorder}
                onReset={resetToDefault}
              />
              <div className='overflow-x-auto'>
                {currentTable !== null && currentTable !== undefined && (
                  <table>
                    <thead>
                      <tr>
                        {visibleIndices.map((origIdx) => (
                          <th
                            key={origIdx}
                            style={{ whiteSpace: "nowrap" }}
                            className='text-center'
                          >
                            {headers[origIdx]}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {currentTable &&
                        currentTable?.body !== null &&
                        currentTable?.body !== undefined &&
                        Array.isArray(currentTable?.body) &&
                        currentTable?.body?.length > 0 ? (
                        currentTable?.body?.map((row, rowInd) => {
                          return (
                            <tr key={rowInd}>
                              {visibleIndices.map((origIdx) => {
                                const item = row?.[origIdx];
                                return (
                                  <td
                                    className={
                                      currentTable?.alignments?.includes(
                                        `${origIdx}`
                                      )
                                        ? "text-right"
                                        : "text-center"
                                    }
                                    key={origIdx}
                                  >
                                    {
                                      currentTable.linkIndex === origIdx ?
                                        <Link
                                          to={`/customerid/${item}`}
                                          onClick={() => tabsChange(item)}
                                          className={
                                            currentTable?.alignments?.includes(
                                              `${origIdx}`
                                            )
                                              ? "text-right"
                                              : "text-center"
                                          }
                                          key={origIdx}
                                        >
                                          {item}
                                        </Link>
                                        :
                                        item
                                    }
                                  </td>
                                )
                              })}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={100} className='text-center text-muted-foreground text-base py-8'>No Data Found</td>
                        </tr>
                      )}

                      {isLast &&
                        parentProps?.tableData !== undefined &&
                        parentProps?.tableData !== null &&
                        Array.isArray(parentProps?.tableData) &&
                        parentProps?.tableData?.length > 0 &&
                        currentTable?.body?.length > 0 &&
                        currentTable?.body?.slice(
                          0,
                          currentTable?.body?.length
                        )[0] !== undefined &&
                        currentTable?.body.slice(
                          0,
                          currentTable?.body?.length
                        )[0] !== null &&
                        currentTable?.body.slice(
                          0,
                          currentTable?.body?.length
                        )[0].length > 0 && (
                          <tr>
                            <td
                              colSpan={isLast && visibleIndices?.length}
                            >
                              <div
                                className='CMS-filter-result'
                                id='result'
                              >
                                <div className='py-4'>
                                  <div className='CMS-pagination-container flex justify-center'>
                                    <div className='CMS-page-slection '>
                                      <div className='relative'>
                                        <select
                                          id='country'
                                          name='File'
                                          onChange={(event) =>
                                            parentProps?.setFileType(
                                              event.target.value
                                            )
                                          }
                                          className="w-full px-3 py-2 border border-input bg-background text-foreground rounded-md focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
                                        >
                                          <option value='PDF'>
                                            PDF
                                          </option>
                                          <option value='CSV'>
                                            CSV
                                          </option>
                                        </select>
                                      </div>
                                      <div className='CMS-download-icon'>
                                        {parentProps?.fileType === "CSV" ? (
                                          <CSVLink
                                            style={{
                                              color: "#fff",
                                            }}
                                            data={parentProps?.csvData}
                                            filename={`${parentProps?.fileName}.csv`}
                                          >
                                            <Download size={20} />
                                          </CSVLink>
                                        ) : (
                                          <Link
                                            to={{}}
                                            onClick={() =>
                                              parentProps?.printPdf()
                                            }
                                            style={{
                                              color: "#fff",
                                            }}
                                          >
                                            <Download size={20} />
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Timestampmsg />
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-20'></div>
    </React.Fragment>
  );
};

const ReportsTable = (props) => {
  const dispatch = useDispatch();
  const tabStack = useSelector(state => state.sidebar.tabStack);
  const tabsChange = (item) => {
    dispatch(tabManager(+item, tabStack));
    localStorage.setItem("userId", item);
  };

  return (
    <>
      {!props.viewTable && <Skelton />}

      {props.viewTable &&
        props?.tableData !== undefined &&
        props?.tableData !== null &&
        props?.tableData?.length > 0 &&
        props?.tableData.map((currentTable, ind) => (
          <ReportSubTable
            key={currentTable.subtitle}
            currentTable={currentTable}
            isLast={props.tableData?.length - 1 === ind}
            tabsChange={tabsChange}
            parentProps={props}
          />
        ))}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    viewTable: state.reports.viewTable,
  };
};
export default connect(mapStateToProps)(ReportsTable);
